import { Component, OnInit, HostBinding } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MFormation, MSearch } from '@argalis-apps/models';
import { SearchService } from '../../services/search/search.service';
import { CatalogConfigService } from '../../services/catalog-config/catalog-config.service';

@Component({
  selector: 'ags-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.scss']
})
export class SearchResultComponent implements OnInit {
  @HostBinding('class') themeFlag: string;
  // Criteres de recherche
  searchOption: MFormation.IFormSearchParams;
  // résultat de recherche
  formResList: MFormation.IFormOverview[] = [];
  searchMatchCount = 0;
  pageSize = 9;

  cardBackground = 'white';
  secondSearch = false;

  constructor(
    private route: ActivatedRoute,
    private searchService: SearchService,
    catalogConfigService: CatalogConfigService
  ) {
    this.themeFlag = `${this.themeFlag || ''} ${catalogConfigService.themingClassName}`;
  }

  ngOnInit() {
    this.route.queryParams.subscribe(async params => {
      this.searchOption = {
        searchText: params['text'] || '',
        dateDebut: params['debut'] || '',
        dateFin: params['fin'] || '',
        domaineId: params['domId'] || '',
        typeDomaine: params['domType'] || '',
        dureeOptionId: params['duree'] || '',
        modaliteId: params['moda'] || '',
        postCode: params['postal'] || '',
        pageSize: `${this.pageSize}`,
        offset: '0'
      };
      this.searchService.searchForForms(this.searchOption).subscribe(
        (data: any) => {
          if (!data) {
            return;
          }
          this.formResList = data.matchList;
          this.searchMatchCount = data.matchCount;
          this.secondSearch = data.secondSearch;
        },
        error => console.log(error)
      );
    });
  }

  getMore() {
    // appel au back pour ajouter une page de résultats à this.formResList
    this.searchOption.offset = `${this.formResList.length}`;
    this.searchService
      .searchForForms(this.searchOption)
      .subscribe((data: MSearch.ISearchResult<MFormation.IFormOverview>) => {
        if (!data) {
          return;
        }
        this.searchMatchCount = data.matchCount;
        this.formResList.push(...data.matchList);
      });
  }
}
